<template>
  <div class="parking-space-rule">
    <div class="page-header">
      <el-page-header @back="goBack" content="共享车位收费规则">
        <template #content>
          
          <div class="header-content">
            <i class="el-icon-setting"></i>
            <span class="title">共享车位收费规则配置</span>
          </div>
            
        </template>
       
      </el-page-header>
       <el-button
          type="primary"
          size="large"
          :disabled="!isSubmitFinite"
          @click="onSubmitBtn"
          class="submit-btn"
        >
          <i class="el-icon-check"></i>
          保存规则
        </el-button>
    </div>

    <div class="form-container">
      <el-card class="rule-card" shadow="hover">
        <div slot="header" class="card-header">
          <i class="el-icon-tickets"></i>
          <span>基础信息</span>
        </div>
        
        <el-form
          ref="form"
          :model="formData"
          label-width="140px"
          class="rule-form"
        >
          <div class="form-section">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="车场名称" required>
                  <el-select
                    v-model="formData.parkingId"
                    @change="onParkChange"
                    placeholder="请选择车场"
                    clearable
                    class="full-width"
                  >
                    <el-option
                      v-for="item in parks"
                      :key="item.parkingId"
                      :label="item.parkingName"
                      :value="item.parkingId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域名称" required>
                  <el-select
                    v-model="formData.areaId"
                    placeholder="请选择区域"
                    clearable
                    class="full-width"
                  >
                    <el-option
                      v-for="item in areas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="规则名称" required>
                  <el-input
                    v-model="formData.name"
                    placeholder="请输入规则名称"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收费模式" required>
                  <el-select
                    v-model="formData.chargeMode"
                    placeholder="请选择收费模式"
                    class="full-width"
                  >
                    <el-option label="24小时" value="HOUR"></el-option>
                    <el-option label="白天/黑夜" value="DAY"></el-option>
                    <el-option label="自定义" value="CUSTOM"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="车辆类型" required>
                  <el-select
                    v-model="formData.carType"
                    placeholder="请选择车辆类型"
                    class="full-width"
                  >
                    <el-option label="大车" value="BIG"></el-option>
                    <el-option label="小车" value="SMALL"></el-option>
                    <el-option label="新能源" value="ENERGY"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车牌类型" required>
                  <el-select
                    v-model="formData.plateType"
                    placeholder="请选择车牌类型"
                    class="full-width"
                  >
                    <el-option label="临时车" value="TEMP"></el-option>
                    <el-option label="储值车" value="SAVE"></el-option>
                    <el-option label="预约车" value="APPOINT"></el-option>
                    <el-option label="违约车" value="DEBT"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-card>

      <el-card class="rule-card" shadow="hover">
        <div slot="header" class="card-header">
          <i class="el-icon-money"></i>
          <span>收费配置</span>
        </div>
        
        <el-form
          :model="formData"
          label-width="140px"
          class="rule-form"
        >
          <div class="form-section">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="收费限额" required>
                  <el-input
                    v-model="formData.quota"
                    placeholder="请输入金额"
                    clearable
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="限额类型" required>
                  <el-select
                    v-model="formData.quotaType"
                    placeholder="请选择限额类型"
                    class="full-width"
                  >
                    <el-option label="当次限额" value="LIMIT_TYPE_ONCE"></el-option>
                    <el-option label="24小时" value="LIMIT_TYPE_24"></el-option>
                    <el-option label="自然天" value="LIMIT_TYPE_NATURAL"></el-option>
                    <el-option label="白天黑夜" value="LIMIT_TYPE_DAY"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="计费类型" required>
                  <el-select
                    v-model="formData.chargeType"
                    placeholder="请选择计费类型"
                    class="full-width"
                  >
                    <el-option label="按次" value="NEXT"></el-option>
                    <el-option label="按时" value="TIME"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="免费时间" required>
                  <el-input
                    v-model="formData.freeTime"
                    placeholder="请输入免费时间"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="循环计费包含" required>
                  <el-select
                    v-model="formData.circularBillingType"
                    placeholder="请选择循环计费类型"
                    class="full-width"
                  >
                    <el-option label="含首时段不含免费时段" value="FIRST"></el-option>
                    <el-option
                      label="不含免费时段与首时段"
                      value="FREE_FIRST_NOT"
                    ></el-option>
                    <el-option
                      label="含免费时段与首时段"
                      value="FREE_AND_FIRST"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="延续类型" required>
                  <el-select
                    v-model="formData.continueType"
                    placeholder="请选择延续类型"
                    class="full-width"
                  >
                    <el-option label="无" value="NO"></el-option>
                    <el-option label="当前限额周期" value="CURRENT_LIMIT"></el-option>
                    <el-option label="后一个限额周期" value="NEXT_LIMIT"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-card>

      <el-card class="rule-card" shadow="hover">
        <div slot="header" class="card-header">
          <i class="el-icon-time"></i>
          <span>时段收费详情</span>
        </div>
        
        <el-form
          :model="formData"
          label-width="160px"
          class="rule-form"
        >
          <div class="form-section">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="免费时长" required>
                  <el-input
                    v-model="formData.dayParting[0].freeTime"
                    placeholder="请输入免费时长"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时段限额" required>
                  <el-input
                    v-model="formData.dayParting[0].quota"
                    placeholder="请输入限额"
                    clearable
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="首段时长" required>
                  <el-input
                    v-model="formData.dayParting[0].firstTime"
                    placeholder="请输入首段时长"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="首段收费" required>
                  <el-input
                    v-model="formData.dayParting[0].firstTimeCharge"
                    placeholder="请输入收费金额"
                    clearable
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="超首段时长后每" required>
                  <el-input
                    v-model="formData.dayParting[0].overFirstTime"
                    placeholder="请输入时长"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="超时段收费" required>
                  <el-input
                    v-model="formData.dayParting[0].overFirstTimeCharges"
                    placeholder="请输入收费金额"
                    clearable
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="停车超过" required>
                  <el-input
                    v-model="formData.dayParting[0].stopOverTime"
                    placeholder="请输入时长"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="超时后每" required>
                  <el-input
                    v-model="formData.dayParting[0].stopOverPerTime"
                    placeholder="请输入时长"
                    clearable
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="超时收费" required>
                  <el-input
                    v-model="formData.dayParting[0].stopOverPerTimeCharges"
                    placeholder="请输入收费金额"
                    clearable
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-card>

     
    </div>
  </div>
</template>
<script>
import {
  addShareSpaceChargeRule,
  shareParks,
  areasByShareParkingId,
  editShareSpaceChargeRule,
} from "@/api/url";
export default {
  props: ["parkingId", "areaId", "id", "rule"],
  data() {
    return {
      formData: {
        parkingId: "",
        areaId: "",
        chargeMode: "",
        carType: "",
        plateType: "",
        quotaType: "",
        circularBillingType: "",
        chargeType: "",
        quota: "",
        freeTime: "",
        continueType: "",
      
        dayParting: [
          {
            freeTime: "",
            quota: "",
            firstTime: "",
            firstTimeCharge: "",
            overFirstTime: "",
            overFirstTimeCharges: "",
            stopOverTime: "",
            stopOverPerTime: "",
            stopOverPerTimeCharges: "",
            daypartingType: "ALLDAY",
          },
        ],
      },
      parks: [],
      areas: [],
      isSubmitFinite: true,
    };
  },
  watch: {
    rule: {
      handler(val, oldVal) {
        if (
          val &&
          Object.keys(val).length > 0 &&
          JSON.stringify(oldVal) != JSON.stringify(val)
        ) {
          console.log("rule=>", val);
          const { parkingId } = val;
          this.getAreasByShareParkingId(parkingId);
          this.formData = { ...val };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getShareParks();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        if (res.status == 200) {
          this.parks = res.data.data.rows ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getAreasByShareParkingId(id) {
      this.$get(`${areasByShareParkingId()}/${id}`, {}).then((res) => {
        if (res.status == 200) {
          this.areas = res.data ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onParkChange(id) {
      this.formData.areaId = "";
      this.getAreasByShareParkingId(id);
    },
    onSubmitBtn() {
      const method = this.id ? this.$putRequest : this.$postRequest;
      const path = this.id
        ? editShareSpaceChargeRule()
        : addShareSpaceChargeRule();
      method(path, {
        ...this.formData,
        dayParting: [...this.formData.dayParting],
      }).then((res) => {
        this.$message(res.status == 200 ? "设置成功" : res.message ?? "");
        this.isSubmitFinite = false;
      });
    },
  },
};
</script>
<style scoped>
.parking-space-rule {
  height: 100vh;
  background: #f5f7fa;
  overflow-y: auto;
  overflow-x: hidden;
}

.parking-space-rule .page-header {
  background: #fff;
  padding: 16px 24px;
  margin: 0!important;
  margin-bottom:20px!important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  display:flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.header-content i {
  margin-right: 8px;
  color: #409eff;
  font-size: 20px;
}

.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 40px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
}

.rule-card {
  margin-bottom: 24px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  transition: all 0.3s ease;
}

.rule-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.card-header i {
  margin-right: 8px;
  color: #409eff;
  font-size: 18px;
}

.rule-form {
  padding: 0;
}

.form-section {
  padding: 8px 0;
}

.full-width {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 32px 0;
  background: #fff;
  border-radius: 8px;
  margin-top: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.cancel-btn {
  padding: 12px 32px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  color: #606266;
  background: #fff;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  border-color: #c0c4cc;
  color: #409eff;
}

.submit-btn {
  padding: 12px 32px;
  font-size: 14px;
  border-radius: 6px;
  background: #409eff;
  border-color: #409eff;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.submit-btn:disabled {
  background: #a0cfff;
  border-color: #a0cfff;
  cursor: not-allowed;
}

/* 自定义滚动条样式 */
.parking-space-rule::-webkit-scrollbar,
.form-container::-webkit-scrollbar {
  width: 6px;
}

.parking-space-rule::-webkit-scrollbar-track,
.form-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.parking-space-rule::-webkit-scrollbar-thumb,
.form-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.3s ease;
}

.parking-space-rule::-webkit-scrollbar-thumb:hover,
.form-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

<style>
.parking-space-rule .el-form-item {
  margin-bottom: 22px;
}

.parking-space-rule .el-form-item__label {
  color: #606266;
  font-weight: 500;
  font-size: 14px;
  line-height: 40px;
}

.parking-space-rule .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  transition: all 0.3s ease;
}

.parking-space-rule .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.parking-space-rule .el-select {
  width: 100%;
}

.parking-space-rule .el-select .el-input__inner {
  cursor: pointer;
}

.parking-space-rule .el-input-group__append {
  background: #f5f7fa;
  border-left: 0;
  color: #909399;
  border-radius: 0 6px 6px 0;
  padding: 0 10px;
  font-size: 14px;
  height: 40px;
  line-height: 38px;
  min-width: 50px;
  border: 1px solid #dcdfe6;
  border-left: 0;
}

.parking-space-rule .el-card__header {
  padding: 18px 20px;
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.parking-space-rule .el-card__body {
  padding: 24px 20px;
}

.parking-space-rule .el-form-item.is-required .el-form-item__label::before {
  color: #f56c6c;
  margin-right: 4px;
}

.parking-space-rule .el-button {
  font-weight: 500;
}

.parking-space-rule .el-page-header__content {
  font-size: 18px;
  font-weight: 600;
}
</style>
